/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    PlaylistLibraryExplorePlaylistIdentifier,
    instanceOfPlaylistLibraryExplorePlaylistIdentifier,
    PlaylistLibraryExplorePlaylistIdentifierFromJSON,
    PlaylistLibraryExplorePlaylistIdentifierFromJSONTyped,
    PlaylistLibraryExplorePlaylistIdentifierToJSON,
} from './PlaylistLibraryExplorePlaylistIdentifier';
import {
    PlaylistLibraryFolder,
    instanceOfPlaylistLibraryFolder,
    PlaylistLibraryFolderFromJSON,
    PlaylistLibraryFolderFromJSONTyped,
    PlaylistLibraryFolderToJSON,
} from './PlaylistLibraryFolder';
import {
    PlaylistLibraryPlaylistIdentifier,
    instanceOfPlaylistLibraryPlaylistIdentifier,
    PlaylistLibraryPlaylistIdentifierFromJSON,
    PlaylistLibraryPlaylistIdentifierFromJSONTyped,
    PlaylistLibraryPlaylistIdentifierToJSON,
} from './PlaylistLibraryPlaylistIdentifier';

/**
 * @type UserPlaylistLibraryContentsInner
 * 
 * @export
 */
export type UserPlaylistLibraryContentsInner = PlaylistLibraryExplorePlaylistIdentifier | PlaylistLibraryFolder | PlaylistLibraryPlaylistIdentifier;

export function UserPlaylistLibraryContentsInnerFromJSON(json: any): UserPlaylistLibraryContentsInner {
    return UserPlaylistLibraryContentsInnerFromJSONTyped(json, false);
}

export function UserPlaylistLibraryContentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPlaylistLibraryContentsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return { ...PlaylistLibraryExplorePlaylistIdentifierFromJSONTyped(json, true), ...PlaylistLibraryFolderFromJSONTyped(json, true), ...PlaylistLibraryPlaylistIdentifierFromJSONTyped(json, true) };
}

export function UserPlaylistLibraryContentsInnerToJSON(value?: UserPlaylistLibraryContentsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfPlaylistLibraryExplorePlaylistIdentifier(value)) {
        return PlaylistLibraryExplorePlaylistIdentifierToJSON(value as PlaylistLibraryExplorePlaylistIdentifier);
    }
    if (instanceOfPlaylistLibraryFolder(value)) {
        return PlaylistLibraryFolderToJSON(value as PlaylistLibraryFolder);
    }
    if (instanceOfPlaylistLibraryPlaylistIdentifier(value)) {
        return PlaylistLibraryPlaylistIdentifierToJSON(value as PlaylistLibraryPlaylistIdentifier);
    }

    return {};
}

